export default __webpack_public_path__ + "static/media/win-modal-bg.48a04c30.jpg";